/**
 * Phase 6 Plan 02 — PhotoCountBadge (CONTEXT D-134 photo count rules).
 *
 *   total === 0           → HIST_PHOTO_COUNT_NONE
 *   total > 0, uploading=0 → HIST_PHOTO_COUNT_LANDED count={total}
 *   total > 0, uploading>0 → HIST_PHOTO_COUNT_PARTIAL count={total} uploading={uploading}
 *
 * Latin digits universal in both EN+AR (spec REQUIREMENTS.md I18N-9.6).
 */
import { FormattedMessage } from "react-intl";

interface PhotoCountBadgeProps {
  total: number;
  uploading: number;
  "data-testid"?: string;
}

export function PhotoCountBadge({
  total,
  uploading,
  "data-testid": testId,
}: PhotoCountBadgeProps) {
  if (total === 0) {
    return (
      <span data-testid={testId} className="text-xs text-text-secondary">
        <FormattedMessage id="HIST_PHOTO_COUNT_NONE" />
      </span>
    );
  }
  if (uploading === 0) {
    return (
      <span data-testid={testId} className="text-xs text-on-surface-variant">
        <bdi>
          <FormattedMessage
            id="HIST_PHOTO_COUNT_LANDED"
            values={{ count: total }}
          />
        </bdi>
      </span>
    );
  }
  return (
    <span data-testid={testId} className="text-xs text-warning">
      <bdi>
        <FormattedMessage
          id="HIST_PHOTO_COUNT_PARTIAL"
          values={{ count: total, uploading }}
        />
      </bdi>
    </span>
  );
}
